import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-[#f8fafc]">
      <SEO
        title="Tentang KasirWA"
        description="KasirWA adalah platform POS modern untuk bisnis jasa Indonesia, dilengkapi notifikasi WhatsApp otomatis dan laporan keuangan real-time."
        path="/about"
        keywords="tentang kasirwa, aplikasi kasir indonesia, pos bisnis jasa, kasir laundry, kasir rental"
      />
      <header className="bg-white border-b border-slate-100 px-6 py-4">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 bg-[#0f6c44] rounded-xl flex items-center justify-center">
              <span className="text-white font-bold text-sm">K</span>
            </div>
            <span className="font-bold text-slate-800">KasirWA</span>
          </Link>
          <Link to="/" className="text-sm text-[#0f6c44] hover:underline">Kembali ke Beranda</Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12 space-y-10">
        <div className="text-center space-y-3">
          <div className="w-16 h-16 bg-[#0f6c44] rounded-2xl flex items-center justify-center mx-auto">
            <span className="text-white font-bold text-2xl">K</span>
          </div>
          <h1 className="text-3xl font-bold text-slate-900">Tentang KasirWA</h1>
          <p className="text-slate-500 max-w-lg mx-auto">Platform POS modern untuk bisnis jasa Indonesia, dengan notifikasi WhatsApp terintegrasi.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { title: 'Visi', desc: 'Menjadi platform manajemen bisnis jasa terdepan di Indonesia yang membantu jutaan UMKM tumbuh dengan teknologi.' },
            { title: 'Misi', desc: 'Menyederhanakan operasional bisnis jasa dengan POS yang intuitif, laporan otomatis, dan komunikasi WhatsApp yang efisien.' },
            { title: 'Nilai', desc: 'Mudah digunakan, terpercaya, dan berorientasi pada pertumbuhan bisnis pengguna kami.' },
          ].map(item => (
            <div key={item.title} className="bg-white rounded-2xl border border-slate-100 p-6">
              <h3 className="font-bold text-slate-800 mb-2">{item.title}</h3>
              <p className="text-sm text-slate-500">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl border border-slate-100 p-8">
          <h2 className="text-xl font-bold text-slate-800 mb-4">Fitur Unggulan</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {[
              'Kasir POS untuk 6 tipe bisnis jasa',
              'Kanban board untuk manajemen pesanan',
              'Notifikasi WhatsApp otomatis via Fonnte',
              'Laporan keuangan real-time',
              'Manajemen pelanggan terintegrasi',
              'Kalender booking untuk rental & appointment',
              'Multi-karyawan dengan role berbeda',
              'Lacak pesanan publik tanpa login',
            ].map(f => (
              <div key={f} className="flex items-center gap-2 text-sm text-slate-700">
                <div className="w-5 h-5 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <div className="w-2 h-2 bg-[#0f6c44] rounded-full" />
                </div>
                {f}
              </div>
            ))}
          </div>
        </div>

        <div className="bg-[#0f6c44] text-white rounded-2xl p-8 text-center">
          <h2 className="text-xl font-bold mb-2">Mulai Gratis Sekarang</h2>
          <p className="text-emerald-100 text-sm mb-4">Tidak perlu kartu kredit. Daftar dan kelola bisnis Anda dalam menit.</p>
          <Link to="/register" className="inline-block bg-white text-[#0f6c44] font-bold px-6 py-3 rounded-xl hover:bg-emerald-50 transition-colors">
            Daftar Gratis
          </Link>
        </div>
      </main>

      <footer className="border-t border-slate-200 mt-8 py-8 text-center text-sm text-slate-400">
        <p>&copy; {new Date().getFullYear()} KasirWA. Semua hak dilindungi.</p>
        <div className="flex justify-center gap-4 mt-2">
          <Link to="/privacy" className="hover:text-[#0f6c44]">Privasi</Link>
          <Link to="/terms" className="hover:text-[#0f6c44]">Syarat</Link>
          <Link to="/about" className="hover:text-[#0f6c44]">Tentang</Link>
        </div>
      </footer>
    </div>
  );
}
